import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_HELP_ROUTES as HELP } from "@/Generated/Routes/paths";

export default [
  {
    path: HELP.root.path,
    components: {
      main: () => import("@/Views/settings/help/Layout.vue"),
    },
    meta: { sidebar: false, drawer: false, noHeader: true },
    children: [
      {
        ...HELP.root,
        component: () => import("@/Views/MainLanding.vue"),
      },
      {
        ...HELP.view.root,
        component: () => import("@/Views/settings/help/View.vue"),
        meta: { sidebar: false, drawer: false, noHeader: true },
      },
    ],
  },
] as RouteRecordRaw[];
